import { SearchIconOutline } from '@com/icons';
import { generalTexts } from '@com/texts/generalTexts';
import { colors } from '@configs/Theme';

interface Props {
  className?: string;
  title?: string;
}

const SearchBox = ({ className = '', title }: Props) => {
  return (
    <span
      className={`h-[48px] w-full relative bg-grey-100 rounded-full flex gap-x-2 items-center px-3 py-3 text-sm text-grey-500 ${className}`}
    >
      <SearchIconOutline height={24} width={24} fill={colors?.grey?.[600]} />
      <p className="font-medium">{title ?? generalTexts?.drugSearch} ...</p>
    </span>
  );
};

export default SearchBox;
